import { Controller } from '@hotwired/stimulus'

// A "select all" checkbox over a list of checkboxes: it ticks or clears them
// all, and shows whether all, some or none of them are ticked.
export default class extends Controller {
  static targets = ['all', 'item']

  connect() {
    this.sync()
  }

  toggle() {
    const checked = this.allTarget.checked
    this.itemTargets.forEach(item => {
      if (item.checked === checked) return

      item.checked = checked
      item.dispatchEvent(new Event('change', { bubbles: true }))
    })
    this.sync()
  }

  sync() {
    const checked = this.itemTargets.filter(item => item.checked).length
    this.allTarget.checked = checked > 0 && checked === this.itemTargets.length
    this.allTarget.indeterminate = checked > 0 && checked < this.itemTargets.length
  }
}
